import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ApiService } from 'anatoliapps-angular/services';

import { BankAccount } from 'hakikat/models';
import { API_CONFIG } from 'hakikat/utils';

@Injectable({
  providedIn: 'root'
})
export class BankService extends ApiService {

  //#region Endpoints
  readonly #BANKS_ENDPOINT = 'bank';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  getBankAccounts(currency?: string): Observable<BankAccount[]> {
    return this.get<BankAccount[]>(`${this.#BANKS_ENDPOINT}${currency ? `?currency=${currency}` : ''}`);
  }
  //#endregion

}
